export default "__VITE_ASSET__CsjzdxfD__"